import { createFeature, createReducer, on } from '@ngrx/store';

import { PartnerManagementActions } from './partner-management.actions';
import { initialPartnerManagementState } from './partner-management.state';

export const partnerManagementFeature = createFeature({
  name: 'partnerManagement',
  reducer: createReducer(
    initialPartnerManagementState,
    on(PartnerManagementActions.loadList, (state, { query }) => ({
      ...state,
      loadingList: true,
      error: null,
      listError: null,
      currentPage: query.page,
      pageSize: query.pageSize,
    })),
    on(
      PartnerManagementActions.loadListSuccess,
      (state, { rows, total, page, pageSize, counts }) => ({
        ...state,
        rows,
        totalPartners: total,
        counts,
        currentPage: page,
        pageSize,
        loadingList: false,
        listError: null,
      }),
    ),
    on(PartnerManagementActions.loadListFailure, (state, { error }) => ({
      ...state,
      rows: [],
      totalPartners: 0,
      loadingList: false,
      error,
      listError: error,
    })),
    on(PartnerManagementActions.loadPartner, (state, { partnerId }) => ({
      ...state,
      loadingDetail: true,
      error: null,
      selectedPartner: null,
      selectedPartnerId: partnerId,
    })),
    on(PartnerManagementActions.loadPartnerSuccess, (state, { partner }) => ({
      ...state,
      loadingDetail: false,
      selectedPartner: partner,
      selectedPartnerId: partner.partner_id,
    })),
    on(PartnerManagementActions.loadPartnerFailure, (state, { error }) => ({
      ...state,
      loadingDetail: false,
      error,
      selectedPartner: null,
    })),
    on(PartnerManagementActions.loadSchedule, (state, { partnerId, query }) => ({
      ...state,
      loadingSchedule: true,
      scheduleError: null,
      scheduleMutationError: null,
      schedulePartnerId: partnerId,
      scheduleQuery: query,
    })),
    on(PartnerManagementActions.loadScheduleSuccess, (state, { partnerId, query, schedule }) => ({
      ...state,
      schedule,
      schedulePartnerId: partnerId,
      scheduleQuery: query,
      loadingSchedule: false,
      scheduleError: null,
    })),
    on(PartnerManagementActions.loadScheduleFailure, (state, { error }) => ({
      ...state,
      schedule: null,
      loadingSchedule: false,
      scheduleError: error,
    })),
    on(PartnerManagementActions.updateScheduleAvailability, (state) => ({
      ...state,
      updatingScheduleAvailability: true,
      scheduleMutationError: null,
    })),
    on(PartnerManagementActions.updateScheduleAvailabilitySuccess, (state) => ({
      ...state,
      updatingScheduleAvailability: false,
    })),
    on(PartnerManagementActions.updateScheduleAvailabilityFailure, (state, { error }) => ({
      ...state,
      updatingScheduleAvailability: false,
      scheduleMutationError: error,
    })),
    on(
      PartnerManagementActions.createPartner,
      PartnerManagementActions.updatePartner,
      PartnerManagementActions.updatePartnerStatus,
      (state) => ({
        ...state,
        submitting: true,
        error: null,
        successMessage: null,
      }),
    ),
    on(PartnerManagementActions.persistSuccess, (state, { message, partner }) => ({
      ...state,
      submitting: false,
      successMessage: message,
      selectedPartner: partner,
      selectedPartnerId: partner.partner_id,
    })),
    on(PartnerManagementActions.updatePartnerStatusSuccess, (state, { message, partner }) => ({
      ...state,
      submitting: false,
      successMessage: message,
      selectedPartner: partner,
      selectedPartnerId: partner.partner_id,
    })),
    on(
      PartnerManagementActions.persistFailure,
      PartnerManagementActions.updatePartnerStatusFailure,
      (state, { error }) => ({
        ...state,
        submitting: false,
        error,
      }),
    ),
    on(PartnerManagementActions.clearError, (state) => ({
      ...state,
      error: null,
      listError: null,
    })),
    on(PartnerManagementActions.clearSuccessMessage, (state) => ({
      ...state,
      successMessage: null,
    })),
  ),
});

export const {
  name: partnerManagementFeatureKey,
  reducer: partnerManagementReducer,
  selectRows,
  selectCounts,
  selectTotalPartners,
  selectLoadingList,
  selectLoadingDetail,
  selectListError,
  selectSubmitting,
  selectError,
  selectSuccessMessage,
  selectSelectedPartner,
  selectSelectedPartnerId,
  selectSchedule,
  selectSchedulePartnerId,
  selectScheduleQuery,
  selectLoadingSchedule,
  selectUpdatingScheduleAvailability,
  selectScheduleError,
  selectScheduleMutationError,
  selectCurrentPage,
  selectPageSize,
} = partnerManagementFeature;
